import { Injectable, OnDestroy, Inject } from '@angular/core';
import { Observable, SubscriptionLike, Subject, Observer, interval, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WebSocketSubject, WebSocketSubjectConfig } from 'rxjs/webSocket';

import { share, distinctUntilChanged, takeWhile } from 'rxjs/operators';
import { IWebsocketService, IWsMessage, WebSocketConfig } from './websocket.interfaces';
import { config } from './websocket.config';
import { ApiOrganizationsService, ApiUsersService } from '../services';


@Injectable({
    providedIn: 'root'
})
export class WebsocketService implements IWebsocketService, OnDestroy {

    private config: WebSocketSubjectConfig<IWsMessage<any>>;

    private websocketSub: SubscriptionLike;
    private statusSub: SubscriptionLike;

    private reconnection$: Observable<number>;
    private websocket$: WebSocketSubject<IWsMessage<any>>;
    private connection$: Observer<boolean>;
    private wsMessages$: Subject<IWsMessage<any>>;

    private reconnectInterval: number;
    private reconnectAttempts: number;
    private isConnected: boolean;


    public status: Observable<boolean>;

    constructor(
        @Inject(config) private wsConfig: WebSocketConfig,
        private apiUsers: ApiUsersService,
        private apiOrganizations: ApiOrganizationsService
    ) {

        console.log('[WEBSOCKET] start');

        this.wsMessages$ = new Subject<IWsMessage<any>>();

        this.reconnectInterval = wsConfig.reconnectInterval || 5000; // pause between connections
        this.reconnectAttempts = wsConfig.reconnectAttempts || 10; // number of connection attempts

        this.config = {
            url: wsConfig.url,
            closeObserver: {
                next: (event: CloseEvent) => {
                    console.log('[WEBSOCKET] disconnected!');
                    this.websocket$ = null;
                    this.connection$.next(false);
                }
            },
            openObserver: {
                next: (event: Event) => {
                    console.log('[WEBSOCKET] connected!');
                    this.connection$.next(true);
                }
            }
        };

        // connection status
        this.status = new Observable<boolean>((observer) => {
            this.connection$ = observer;
        }).pipe(share(), distinctUntilChanged());

        // run reconnect if not connection
        this.statusSub = this.status.subscribe((isConnected) => {
                
            this.isConnected = isConnected;

            if (!this.reconnection$ && typeof(isConnected) === 'boolean' && !isConnected) {
                console.log('isConnected: ', isConnected)
                this.reconnect();
            }
        });

        this.websocketSub = this.wsMessages$.subscribe(
            null, (error: ErrorEvent) => console.error('[WEBSOCKET] error!', error)
        );


        // this.connect();


        // // добавление идентификатора пользователя
        // if(this.apiUsers.userInfo != null){

        //     this.config.url = wsConfig.url + '?userId=' + this.apiUsers.userInfo.id;
        //     console.log('[WEBSOCKET] url connect.: ', this.config.url);
        //     this.connect();
        // }

        // this.apiUsers.userInfoSubject.subscribe(data => {
        //     this.config.url = wsConfig.url + '?userId=' + data.id;
        //     console.log('[WEBSOCKET] url connect: ', this.config.url);
        //     this.connect();
        // });

        // // добавление идентификатора пользователя и организации
        // if(this.apiUsers.userInfo != null && this.apiOrganizations.currentOrganization != null){

        //     this.config.url = wsConfig.url + '?userId=' + this.apiUsers.userInfo.id + '&orgId=' + this.apiOrganizations.currentOrganization.id;
        //     console.log('[WEBSOCKET] url reconnect.: ', this.config.url);
        //     this.reconnect();
        // }

        // this.apiOrganizations.currentOrganizationSubject.subscribe(data => {

        //     if(this.apiUsers.userInfo != null){
                
        //         this.config.url = wsConfig.url + '?userId=' + this.apiUsers.userInfo.id + '&orgId=' + data.id;
        //         console.log('[WEBSOCKET] url reconnect: ', this.config.url);
        //         this.reconnect();
        //     }
        // });



        // !!! возможно потребуется передача идентификатора пользователя... или токена, а так же идентификатора организации
        // ws://128.10.10.224:8080/websocket-server/nct-websocket?userId=12345&orgId=321654987
    }

    ngOnDestroy() {

        this.websocketSub.unsubscribe();
        this.statusSub.unsubscribe();
    }


    /**
     * connect to WebSocked
     */
    private connect(): void {
        this.websocket$ = new WebSocketSubject(this.config);

        this.websocket$.subscribe(
            (message) => this.wsMessages$.next(message),
            (error: Event) => { 
                console.error('error conect: ', error)
                if (!this.websocket$) {
                    // run reconnect if errors
                    this.reconnect();
                }
            });
    }


    /**
     * reconnect if not connecting or errors
     */
    private reconnect(): void {
        this.reconnection$ = interval(this.reconnectInterval)
            .pipe(takeWhile((v, index) => index < this.reconnectAttempts && !this.websocket$));

        this.reconnection$.subscribe(
            () => this.connect(),
            null,
            () => {
                // Subject complete if reconnect attemts ending
                this.reconnection$ = null;

                if (!this.websocket$) {
                    this.wsMessages$.complete();
                    this.connection$.complete();
                }
            });
    }


    /**
     * on message event
     * @param event 
     * @returns 
     */
    public on<T>(event: string): Observable<T> {

        if (event) {
            return this.wsMessages$.pipe(
                filter((message: IWsMessage<T>) => message.event === event),
                map((message: IWsMessage<T>) => message.content)
            );
        }
    }


    /**
     * on message to server
     * @param event 
     * @param data 
     */
    public send(event: string, data: any = {}): void {
        if (event && this.isConnected) {
            this.websocket$.next({ event: event, content: data });
        } else {
            console.error('[WEBSOCKET] Send error!');
        }
    }
}
